import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=1b98aab3&scoped=true"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=1b98aab3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98aab3",
  null
  
)

export default component.exports